import { createContext } from 'react';

import { ToastNotificationContext as ToastNotificationContextProps } from './interfaces';

export const ToastNotificationContext = createContext<ToastNotificationContextProps>(
  {} as ToastNotificationContextProps
);
